<div class="wrapper-lg">
    <app-breadcrumbs [items]="[{ url: '/diploma-supplements', text: 'diplomaSupplement_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'diplomaSupplement_listTitle' | translate}}</h1>
        <aside>
            <button type="button" class="btn btn-outline-secondary" (click)="changeContactPerson()" *ngIf="isAdmin">
                <i class="fi fi-rs-user-add"></i>
                {{'diplomaSupplement_btnChangeContactPerson' | translate}}
            </button>
        </aside>
    </header>

    <div class="row">
        <div class="col-md-3 form-field">
            <input class="form-control"
                   name="filterText"
                   [placeholder]="'search' | translate"
                   [ngbTooltip]="'diplomaSupplement_lblSearch' | translate"
                   [(ngModel)]="filters.text"
                   (input)="filter(true)">
        </div>

        <div class="col-md-3 form-field">
            <app-select name="filterProgramme"
                        [placeholder]="'diplomaSupplement_lblProgram' | translate"
                        [options]="filters.program.options"
                        [(ngModel)]="filters.program.value"
                        (selectionChange)="filter()">
            </app-select>
        </div>

        <div class="col-md-3 form-field">
            <app-select name="filterSemester"
                        [placeholder]="'diplomaSupplement_lblSemester' | translate"
                        [options]="filters.semester.options"
                        [(ngModel)]="filters.semester.value"
                        (selectionChange)="filter()">
            </app-select>
        </div>

        <div class="col-md-3 form-field">
            <app-select name="filterContactPerson"
                        [placeholder]="'diplomaSupplement_lblContactPerson' | translate"
                        [options]="filters.contactPerson.options"
                        [(ngModel)]="filters.contactPerson.value"
                        (selectionChange)="filter()">
            </app-select>
        </div>
    </div>

    <app-table [rows]="items"
               [columns]="columns"
               [page]="page"
               [pageSize]="pageSize"
               [total]="total"
               [auto]="false"
               (pageChange)="onPage($event)"
               (sortChange)="onSort($event)">
        <ng-template #rowTemplate let-row>
            <tr>
                <td *ngIf="isAdmin">
                    <app-checkbox (stateChange)="toggle(row.Id)"></app-checkbox>
                </td>
                <td>
                    <a [routerLink]="['/diploma-supplements', row.Id] | localize">
                        {{row.FullName}}
                    </a>
                </td>
                <td>{{row.Upn}}</td>
                <td>{{row.ProgramName}}</td>
                <td>{{row.Language}}</td>
                <td>{{row.ContactPerson}}</td>
                <td>{{Registered}}</td>
            </tr>
        </ng-template>
    </app-table>
</div>
